import React from "react";

import { MenuCategoryDto } from "services/menu/restModels";

import { localizedText } from "shared/lib/localizedMap";
import { ReorderIcon, SearchInput } from "shared/ui";

import {
    Count,
    Divider,
    Empty,
    FooterButton,
    List,
    MAX_VISIBLE_ROWS,
    Name,
    Row,
    RowButton,
    StopDot,
    Wrap,
} from "./styles";

interface CategoryListProps {
    categories: MenuCategoryDto[];
    // Полное число категорий меню (до фильтрации поиском) — по нему считается высота
    // области списка, чтобы карточка не прыгала на каждую введённую букву.
    totalCount: number;
    activeCategoryId: number | null;
    locale: string;
    query: string;
    onQueryChange: (value: string) => void;
    onSelect: (menuCategoryId: number) => void;
    // Порядок категорий показываем только в сайдбаре: в мобильном листе строка
    // выбирает категорию, а всё остальное про неё живёт в её настройках.
    onOpenOrder?: () => void;
}

/*
* Список категорий с поиском и счётчиками. Один компонент и на сайдбар десктопа, и на
* нижний лист мобильного — разметка строки должна совпадать, иначе экраны разъедутся.
* Фон и тень карточки живут не здесь, а в Aside: в листе они были бы лишним слоем.
* */
export const CategoryList = ({
    categories,
    totalCount,
    activeCategoryId,
    locale,
    query,
    onQueryChange,
    onSelect,
    onOpenOrder,
}: CategoryListProps) => (
    <Wrap>
        <SearchInput
            value={query}
            size="small"
            placeholder="Поиск категории"
            onChange={onQueryChange}
        />

        <List $rows={Math.min(Math.max(totalCount, 1), MAX_VISIBLE_ROWS)}>
            {categories.length === 0 ? (
                <Empty>Ничего не нашлось</Empty>
            ) : (
                categories.map((category) => {
                    const active = category.id === activeCategoryId;

                    return (
                        <Row key={category.id} $active={active}>
                            <RowButton
                                type="button"
                                $active={active}
                                $muted={category.isInStopList}
                                onClick={() => onSelect(category.id)}
                            >
                                {category.isInStopList && <StopDot />}
                                <Name>{localizedText(category.name, locale)}</Name>
                                <Count $active={active}>{category.itemsCount}</Count>
                            </RowButton>
                        </Row>
                    );
                })
            )}
        </List>

        {onOpenOrder && (
            <>
                <Divider />
                <FooterButton variant="text" color="neutral" onClick={onOpenOrder}>
                    <ReorderIcon />
                    Порядок категорий
                </FooterButton>
            </>
        )}
    </Wrap>
);
